import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContentByCategory } from 'components';
import { getCurrentCategory, getAllCategories, isFetchingCategories, isFetchingCategory } from 'redux/reducers';
import { hasSubscription, getToken } from 'redux/query';
import { Spinner } from 'Common';
import { useParams } from 'react-router-dom';
import { getCategoriesTitle, getCategoryBySlug } from 'redux/actions';

const CategoryContainer = () => {
  const dispatch = useDispatch();

  const categories = useSelector(getAllCategories);
  const category = useSelector(getCurrentCategory);
  const isSubscribed = useSelector(hasSubscription);
  const token = useSelector(getToken);
  const isFetching = useSelector((state) => isFetchingCategories(state) || isFetchingCategory(state));
  const { slug } = useParams();

  useEffect(() => {
    if (token) {
      dispatch(getCategoryBySlug(slug));
      dispatch(getCategoriesTitle());
    }
  }, [token, slug]);

  if (isFetching) {
    return <Spinner />;
  }

  return <ContentByCategory categories={categories} category={category} hasSubscription={isSubscribed} />;
};

export default CategoryContainer;
